
<template>
  <nav id="menu">
      <a href="#" v-if="options.menuOptions.navicon" @click="openGroupPersistance">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.66666 10H25.3333M6.66666 16H25.3333M6.66666 22H25.3333" stroke="black" stroke-miterlimit="10" stroke-linecap="round"/>
        </svg>
      </a>
      <a href="#" v-if="options.menuOptions.close" @click="closeGroupPersistance">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="32" height="32" rx="4" />
            <path d="M25 7L7 25M25 25L7 7L25 25Z" stroke="black" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </a>
      <a href="#" v-if="options.menuOptions.back" @click="back">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15.2499 25L6.24994 16L15.2499 7M7.49994 16H25.7499" stroke="black" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </a>
      <a href="#" v-if="options.menuOptions.remote" @click="remote" :class="{ active : options.remoteActive}">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0)">
          <path d="M13.2954 14.8985C13.1283 15.067 13.1283 15.3397 13.2954 15.5077C13.4626 15.6762 13.7327 15.6762 13.8998 15.5077C14.4148 14.9885 15.0991 14.7025 15.8261 14.7025C16.5532 14.7025 17.2374 14.9885 17.7525 15.5077C17.8358 15.5917 17.9452 15.6339 18.0547 15.6339C18.1641 15.6339 18.2735 15.5917 18.3568 15.5077C18.524 15.3397 18.524 15.067 18.3568 14.8985C17.6802 14.2165 16.7814 13.8408 15.8261 13.8408C14.8709 13.8408 13.972 14.2165 13.2954 14.8985Z" fill="black"/>
          <path d="M22.0299 14.0454C22.1393 14.0454 22.2488 14.0031 22.3321 13.9191C22.4992 13.7507 22.4992 13.4784 22.3321 13.3099C18.7449 9.69356 12.9073 9.69356 9.32047 13.3099C9.15335 13.4784 9.15335 13.7507 9.32047 13.9191C9.48758 14.0876 9.75771 14.0876 9.92483 13.9191C13.1787 10.6392 18.4739 10.6392 21.7277 13.9191C21.8111 14.0031 21.9205 14.0454 22.0299 14.0454Z" fill="black"/>
          <path d="M6.44661 11.7813C8.9538 9.25367 12.285 7.86166 15.8261 7.86166C19.3672 7.86166 22.6985 9.25367 25.2056 11.7813C25.289 11.8654 25.3984 11.9076 25.5078 11.9076C25.6172 11.9076 25.7267 11.8654 25.81 11.7813C25.9771 11.6129 25.9771 11.3406 25.81 11.1722C23.1412 8.48162 19.5955 7 15.8261 7C12.0568 7 8.511 8.48162 5.84226 11.1722C5.67514 11.3406 5.67514 11.6129 5.84226 11.7813C6.00937 11.9498 6.2795 11.9494 6.44661 11.7813Z" fill="black"/>
          <path d="M8.56012 36.7273C8.56012 39.9327 11.8319 42.3281 14.7576 42.3281H16.8946C19.8202 42.3281 23.0921 39.9327 23.0921 36.7273V23.8024C23.0921 20.5971 19.8202 18.2017 16.8946 18.2017H14.7576C11.8319 18.2017 8.56012 20.5971 8.56012 23.8024V36.7273ZM9.41494 23.8024C9.41494 21.0899 12.2358 19.0633 14.7576 19.0633H16.8946C19.4163 19.0633 22.2372 21.0899 22.2372 23.8024V36.7273C22.2372 39.4398 19.4163 41.4664 16.8946 41.4664H14.7576C12.2358 41.4664 9.41494 39.4398 9.41494 36.7273V23.8024Z" fill="black"/>
          <path d="M15.8261 29.1876C17.8294 29.1876 19.4591 27.5449 19.4591 25.5256C19.4591 23.5063 17.8294 21.8635 15.8261 21.8635C13.8228 21.8635 12.1931 23.5063 12.1931 25.5256C12.1931 27.5449 13.8228 29.1876 15.8261 29.1876ZM15.8261 22.7252C17.3579 22.7252 18.6043 23.9815 18.6043 25.5256C18.6043 27.0697 17.3579 28.326 15.8261 28.326C14.2943 28.326 13.0479 27.0697 13.0479 25.5256C13.0479 23.9815 14.2943 22.7252 15.8261 22.7252Z" fill="black"/>
          </g>
          <defs>
          <clipPath id="clip0">
          <rect width="32" height="32" rx="4" fill="white"/>
          </clipPath>
          </defs>
        </svg>
      </a>
  </nav>
</template>

<script>

export default {
  name: 'Menu',
  computed: {
    options(){
      return this.$store.state.UIstate;
    },
    remoteActive(){
      return this.$store.state.UIstate.remoteActive;
    }
  },
  methods: {
    openGroupPersistance(){
      this.$store.commit('configMenuUI', { close: true, navicon: false });
      this.$store.commit('toggleGroupPersistance');
    },
    closeGroupPersistance(){
      this.$store.commit('configMenuUI', { close: false, navicon: true });
      this.$store.commit('toggleGroupPersistance');
    },
    back(){
      this.$router.go(-1);
    },
    remote(){
      this.$store.commit('toggleRemoteForm');
    }
  }
}
</script>

<style lang="scss">
@import '../scss/variables';

$base: 2.4rem;

#menu {
    position: fixed;
    top: 1.5rem;
    left: 1.5rem;
    background: white;
    box-shadow: 0 0 .5rem rgba($color: #000000, $alpha: .2);
    display: flex;
    flex-direction: column;
    padding: .5rem;
    gap: .5rem;
    border-radius: .25rem;
    z-index: 9999;

    > a {
        padding: 0;
        @include center;
        height: $base;
        width: $base;
        border-radius: .25rem;
        background: #EEE;
        transition: all .2s ease;

        &.active {
          background: $remoteRed;
          
          svg {
                path, line, circle {
                    fill: #eee;
                }
            }

        }

        svg {
//            transform: rotateZ(0);
//            transition: all .2s ease-out;
        }

        &:hover {
            background: #222;

            svg {
                //transform: rotateZ(180deg);

                path, line, circle {
                    stroke: #eee;
                }
            }

        }
    }

}
</style>